import React from 'react';
import { useContextState } from '../StateProvider';
import { useTranslation } from 'next-i18next';
import isEmpty from '../../utils/isEmpty';
// import PropTypes from 'prop-types';
import styles from './SearchShowMore.module.scss';

const SearchShowMore = () => {
    const { t } = useTranslation('common');
    const [{ meta } = {}, dispatch] = useContextState();

    if (isEmpty(meta) || !meta?.next) {
        return null;
    }

    return (
        <div className={styles['SearchShowMore']}>
            <div className={styles['SearchShowMore__Wrapper']}>
                <h2 className="sr-only">{t('search.paginationTitle')}</h2>
                <div className={styles['SearchShowMore__Progress']}>
                    {t('search.progress', {
                        shownHits: meta.shownHits,
                        totalHits: meta.totalHits,
                    })}
                </div>
                <div className={styles['SearchShowMore__ProgressBar']}>
                    <div
                        className={styles['SearchShowMore__ProgressBarIndicator']}
                        style={{
                            width: `${(meta.shownHits / meta.totalHits) * 100}%`,
                        }}
                    />
                </div>
                <button
                    onClick={() => {
                        dispatch({
                            type: 'set_current_page',
                            payload: meta.next,
                        });
                        dispatch({ type: 'set_searching', payload: true });
                    }}
                    className={styles['SearchShowMore__Button']}>
                    {t('search.loadMore')}
                </button>
            </div>
        </div>
    );
};

SearchShowMore.propTypes = {};

export default SearchShowMore;
